import {Paper, Stepper, styled} from '@mui/material';

const Container = styled(Paper)`
	flex-direction: column;
	padding: 32px 40px;
	position: sticky;
	display: flex;
	height: 100vh;
	gap: 32px;
	flex: 1;
	top: 0;
	align-items: baseline;
`;

const StepperStyled = styled(Stepper)`
	width: 100%;
`;

export {Container, StepperStyled};
